import { render, staticRenderFns } from "./FavoriteUsers.vue?vue&type=template&id=78005d0d"
import script from "./FavoriteUsers.vue?vue&type=script&lang=ts"
export * from "./FavoriteUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports